var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNew13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.945312,
    y: 0.186279,
    width: 45.1096,
    height: 45.0959,
    rx: 22.5479,
    fill: "#F6F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5974 23.6046C15.5974 25.3907 15.9221 26.6536 16.6257 27.3933C17.0767 27.8623 17.654 28.151 18.4839 28.151C19.3138 28.151 19.8911 27.8623 20.3422 27.3933C21.0458 26.6536 21.3705 25.3907 21.3705 23.6046C21.3705 21.8186 21.0458 20.5557 20.3422 19.816C19.8911 19.3469 19.3138 19.0583 18.4839 19.0583C17.654 19.0583 17.0767 19.3469 16.6257 19.816C15.9221 20.5557 15.5974 21.8186 15.5974 23.6046ZM13.8474 23.6046C13.8474 21.999 14.118 20.5196 14.8938 19.365C15.6515 18.2284 16.8241 17.4887 18.4839 17.4887C20.1437 17.4887 21.3164 18.2284 22.0741 19.365C22.8499 20.5196 23.1205 21.999 23.1205 23.6046C23.1205 25.2103 22.8499 26.6897 22.0741 27.8443C21.3164 28.9809 20.1437 29.7206 18.4839 29.7206C16.8241 29.7206 15.6515 28.9809 14.8938 27.8443C14.118 26.6897 13.8474 25.2103 13.8474 23.6046ZM27.9984 24.0196L27.1324 22.5582L30.5782 19.383H24.9855V17.7593H32.9236V19.3469L29.586 22.432C31.2999 22.432 33.1942 23.5866 33.1942 25.9861C33.1942 27.9525 31.6787 29.7386 28.9545 29.7386C26.2484 29.7386 24.7149 27.9706 24.6066 26.0582L26.3386 25.6613C26.4107 27.2129 27.5293 28.1871 28.9365 28.1871C30.5422 28.1871 31.4081 27.1948 31.4081 26.0221C31.4081 24.4886 30.1813 23.8392 29.0267 23.8392C28.6659 23.8392 28.3051 23.9113 27.9984 24.0196Z",
    fill: "#0F345A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew13);
export default __webpack_public_path__ + "static/media/new13.fafdc8b55a773d7f535cd81015672ee1.svg";
export { ForwardRef as ReactComponent };